import React from "react";

export default function ProductPlaceholder() {
    return (
        <div
            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 themed-grid-col text-center"
            aria-hidden="true"
        >
            <div className="placeholder-glow ">
                <div
                    className="bg-secondary  placeholder "
                    style={{
                        width: "150",
                        height: "150",
                    }}
                />
            </div>

            <div className="card-body">
                <h5 className="card-title placeholder-glow hstack gap-1">
                    <span className="placeholder col-6"></span>
                    <span
                        href="#"
                        tabIndex="-1"
                        className="bg-primary  placeholder col-6"
                    ></span>
                </h5>
                <h5 className="card-title placeholder-glow">
                    <span
                        href="#"
                        tabIndex="-1"
                        className="bg-primary  placeholder col-6"
                        style={{
                            padding: "0.375rem 0.75rem",
                            borderRadius: "0.25rem",
                        }}
                    ></span>
                </h5>
            </div>
        </div>
    );
}

export const CertificateStickerPlaceholder = () => {
    return (
        <div
            className="bg-secondary  placeholder"
            style={{ width: "50", height: "50", margin: "2px" }}
        ></div>
    );
};

export const ThumbnailsPlaceholder = () => {
    return (
        <div
            className="bg-secondary  placeholder"
            style={{ width: "70", height: "70", margin: "2px" }}
        ></div>
    );
};

export const AboutProductPlaceholder = () => {
    return (
        <div className="px-4">
            <h2 className="row placeholder-glow">
                <span className="col-3 placeholder"></span>
            </h2>
            <div className="row placeholder-glow hstack gap-1">
                <p className="placeholder col-3"></p>
                <p className="placeholder col-7"></p>
                <p className="placeholder col-8"></p>
                <p className="placeholder col-4"></p>
                <p className="placeholder col-5"></p>
            </div>
        </div>
    );
};

export const FeaturesBenefitsPlaceholder = () => {
    return (
        <div className="px-4">
            <h2 className="row placeholder-glow">
                <span className="col-3 placeholder"></span>
            </h2>
            <div className="mw-900 d-flex justify-content-between">
                <div className="w-50 pe-4">
                    <div className="row placeholder-glow ">
                        <p className="placeholder"></p>
                        <p className="placeholder"></p>
                        <p className="placeholder"></p>
                        <p className="placeholder"></p>
                        <p className="placeholder"></p>
                    </div>
                </div>
                <div className="w-50 px-4">
                    <div className="row placeholder-glow">
                        <p className="placeholder"></p>
                        <p className="placeholder"></p>
                        <p className="placeholder"></p>
                        <p className="placeholder"></p>
                        <p className="placeholder"></p>
                    </div>
                </div>
            </div>
        </div>
    );
};
